export const isProduction = () =>
  process.env.NODE_ENV === "production" &&
  process.env.REACT_APP_LOBBY_ENV === "production";



// WEBPACK FOOTER //
// ./src/core/env.js